import { render, staticRenderFns } from "./lazyImage.vue?vue&type=template&id=2f637388&scoped=true"
import script from "./lazyImage.vue?vue&type=script&lang=js"
export * from "./lazyImage.vue?vue&type=script&lang=js"
import style0 from "./lazyImage.vue?vue&type=style&index=0&id=2f637388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f637388",
  null
  
)

export default component.exports